import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ReelEvent} from '@nolimitcity/slot-game/bin/core/reel/event/ReelEvent';
import {IReelStoppedData} from '@nolimitcity/slot-game/bin/core/reel/reel/ReelController';
import {Reels} from '@nolimitcity/slot-game/bin/core/reel/reelarea/Reels';
import {ServerEvent} from '@nolimitcity/slot-game/bin/core/server/event/ServerEvent';
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BarbarianFuryGameConfig} from "../../BarbarianFuryGameConfig";
import {BarbarianFuryGameModuleConfig} from '../../BarbarianFuryGameModuleConfig';
import {BarbarianFurySoundConfig} from '../../BarbarianFurySoundConfig';
import {BFGameEvent} from "../../events/BFGameEvent";
import {BarbarianFuryGameMode} from "../../gamemode/BarbarianFuryGameMode";
import {BarbarianFuryParsedGameData} from "../../server/data/BarbarianFuryParsedGameData";
import {BFNudgeStackedWPController} from '../../winpresentation/nudgeStacked/BFNudgeStackedWPController';
import {BFReelAreaView} from "./BFReelAreaView";

export class BFReels extends Reels {
    private _anticipatingReels:boolean[] = [false, false, false, false, false];
    private _gameMode:string;
    private _startAttentionAtReelId:number;
    private _gameData:BarbarianFuryParsedGameData | null;
    private _initReelSet:string[][];
    private _visibleReelSet:string[][];
    private _nextReelSetName:string;
    private _noNudgeReel:number[] = [];
    private _scatterCount:number = 0;
    private _scatterAnticipationPlaying:boolean = false;
    private _scatterPresentReels:number[] = [];
    private _scatterTriggered:boolean = false;
    private _anticipationfailSoundPlayed:boolean = false;
    private currentAnticipationReel = 0;
    private _bigWinAnticipationSoundPlaying:boolean = false;

    protected addEventListeners():void {
        super.addEventListeners && super.addEventListeners();
        EventHandler.addEventListener(this, "reelTeaseStart", (event:GameEvent) => this.onTeaseStart(event.params[0], event.params[1], event.params[2]));
        EventHandler.addEventListener(this, "reelTeaseAbort", (event:GameEvent) => this.onTeaseAbort(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        //    added this event listener to stop anticipation when all reels are stopped.
        EventHandler.addEventListener(this, ReelEvent.ALL_REELS_SPIN_STOPPED, () => {
            SlotGame.sound.stopEffect("anticipation");
        });
    }


    protected onBeforeSpinStart():void {
        super.onBeforeSpinStart();
        this._scatterCount = 0;
    }

    protected onGameDataParsed(data:BarbarianFuryParsedGameData):void {
        this._gameData = data;
        BarbarianFuryGameModuleConfig.gameData=JSON.parse(JSON.stringify(data));
        this._bigWinAnticipationSoundPlaying = false;
        this._anticipationfailSoundPlayed = false;
        this._scatterPresentReels = [];
        this._scatterTriggered = false;
        this._initReelSet = this._gameData!.reels;
        this._visibleReelSet = [];
        this._nextReelSetName = data.nextReelSetName;
        for(let i = 0; i < this._initReelSet.length; i++) {
            for(let j = 0; j < this._initReelSet[i].length; j++) {
                let itemArray = this._initReelSet[i].slice(1, this._initReelSet[i].length - 1);
                this._visibleReelSet.push(itemArray);
                break;
            }
        }

        if(data.nearWinReels.indexOf(true) > -1) {
            this._anticipatingReels = data.nearWinReels;
        }
        if(data.nearWinBigWinReels.indexOf(true) > -1) {
            this._anticipatingReels = data.nearWinBigWinReels;
        }

        this._gameMode = data.mode;
        this._startAttentionAtReelId = this._anticipatingReels.indexOf(true) - 1;

        this._noNudgeReel = [];
        // did it to get last spinning reel from initialStackOverlay.
        if(data.mode.indexOf("RESPIN") !== -1) {
            let arr:number[] = [0, 1, 2, 3, 4];
            for(let index = 0; index < BFNudgeStackedWPController._nudgeData!.initialStackOverlay.length; index++) {
                if(BFNudgeStackedWPController._nudgeData!.initialStackOverlay[index] || data.overlayWildInRespin[index]) {
                    arr.splice(arr.indexOf(index), 1);
                }
            }
            this._noNudgeReel = arr;
        }
    }

    protected onReelSpinStopped(reelId:number):void {
        if(reelId === 4 && this._nextReelSetName !== "FREESPIN_REELSET") {
            EventHandler.dispatchEvent(new GameEvent(BFGameEvent.STOP_SCATEER_ANIMAITON_ON_REEL));
        }
        super.onReelSpinStopped(reelId);
        // added this check to scale up scatter when ever scatter triggered.
        // if (this._scatterCount >= 3 && this._gameMode === BarbarianFuryGameMode.NORMAL) {
        //     let delay = 0;
        //     if (this._scatterCount === 3 && !this._scatterTriggered) {
        //         delay = (reelId === 4) ? 0.3 : delay;
        //         this._scatterTriggered = true
        //         for (let i = 0; i < this._scatterCount; i++) {
        //             for (let j = 0; j < 5; j++) {
        //                 let sym = Reels.getSymbol(this._scatterPresentReels[i], j);
        //                 if (sym!.symName === "S") {
        //                     TweenLite.to(sym!.scale, 0.3, {
        //                         x: 1.3, y: 1.3
        //                     });
        //                 }
        //             }
        //         }
        //     }
        //     if (this._scatterCount > 3 && this._scatterTriggered) {
        //         for (let j = 0; j < 5; j++) {
        //             delay = (reelId === 4) ? 0.3 : delay;
        //             let sym = Reels.getSymbol(reelId, j);
        //             if (sym!.symName === "S") {
        //                 TweenLite.to(sym!.scale, 0.3, {
        //                     x: 1.3, y: 1.3
        //                 });
        //             }
        //         }
        //     }
        //     if (reelId === 4 && this._scatterTriggered) {
        //         TweenLite.delayedCall(delay, () => {
        //             this.scatterBackToNormalTween();
        //         });
        //     }
        // }


        let isWildSymPresent:boolean = ((this._visibleReelSet[reelId]).toString()).indexOf("W") > -1;
        let isWildFullStacked:boolean = true;
        for(let i:number = 0; i < this._visibleReelSet[reelId].length; i++) {
            if(this._visibleReelSet[reelId][i].indexOf("W") === -1) {
                isWildFullStacked = false;
                break;
            }
        }
        let isWildSymNudging:boolean = this._gameData!.doReelNudge[reelId];


        if(isWildFullStacked && ((this._gameMode === BarbarianFuryGameMode.NORMAL && this._gameData!.betWins.length === 0))) {
            EventHandler.dispatchEvent(new GameEvent(BFGameEvent.HIDE_WILD_FIRE));

        }
        if(this._gameMode === BarbarianFuryGameMode.NORMAL) {
            if(this._startAttentionAtReelId === reelId) {
                EventHandler.dispatchEvent(new GameEvent(BFGameEvent.ON_WIN_ANIM_START));
            }
            if(this._anticipatingReels[reelId]) {
                EventHandler.dispatchEvent(new GameEvent(BFGameEvent.ON_WIN_ANIM_STOP));
            }
        }

        if(reelId === 4) {
            this._scatterCount === 0;
            this.currentAnticipationReel = 0;
        }

        if(reelId === BarbarianFuryGameConfig.instance.REELS_NUM - 1) {
            this.onRoundComplete();
        }
    }

    // private scatterBackToNormalTween(): void {
    //     let tl_time: number = this._quickStop ? 0 : 0.3;
    //     for (let i = 0; i < this._scatterCount; i++) {
    //         for (let j = 0; j < 5; j++) {
    //             let sym = Reels.getSymbol(this._scatterPresentReels[i], j);
    //             if (sym!.symName === "S") {
    //                 TweenLite.to(sym!.scale, tl_time, {
    //                     x: 1, y: 1
    //                 });
    //             }
    //         }
    //     }
    // }

    protected onReelBounceStarted(stopData:IReelStoppedData):void {
        super.onReelBounceStarted(stopData);
        let ScatterSymPresent:boolean = ((this._visibleReelSet[stopData.reelId]).toString()).indexOf("S") > -1;
        let isWildSymPresent:boolean = ((this._visibleReelSet[stopData.reelId]).toString()).indexOf("W") > -1;
        let isActiveSymbolPresent:boolean = ((this._visibleReelSet[stopData.reelId]).toString()).indexOf(this._gameData!.activeStackedSymbol) > -1;
        // implementing scatter landing sound
        if(ScatterSymPresent) {
            this._scatterCount++;
            ;
            this._scatterPresentReels.push(stopData.reelId);
            this.playScatterSoundAndAnimation(stopData)
        }

        if(this._gameData!.nearWinBigWinReels[stopData.reelId + 1] && this._gameMode.indexOf("RESPIN") === -1) {
            !this._bigWinAnticipationSoundPlaying && SlotGame.sound.playEffect("anticipation");
            this._bigWinAnticipationSoundPlaying = true;
            BarbarianFuryGameModuleConfig.foregroundAnimation.playRespinAnticipation([stopData.reelId + 1]); // #251
        }

        if(this._gameData!.nearWinBigWinReels.lastIndexOf(true) === stopData.reelId) {
            this.stopReSpinAnticipationSound();
            BarbarianFuryGameModuleConfig.foregroundAnimation.hideAllrespinAnimation(); // #251
        }

        // playing scatter anticipation animation from here on next reel
        // added this.currentAnticipationReel < stopData.reelId to fix #264
        if(this._scatterCount >= 2 && !stopData.quickStop && this._gameMode === BarbarianFuryGameMode.NORMAL && this.currentAnticipationReel < stopData.reelId) {
            this.currentAnticipationReel = stopData.reelId;
            BarbarianFuryGameModuleConfig.foregroundAnimation.playAnticipationAnimation(stopData.reelId + 1);
        }

        // implementing scatter anticipation
        if(stopData.reelId === 4 && this._scatterAnticipationPlaying) {
            if(this._scatterCount < 3) {
                SlotGame.sound.playEffect(BarbarianFurySoundConfig.instance.SCATTER_ANTICIPATION_FAIL);
            }
            SlotGame.sound.stopEffect(BarbarianFurySoundConfig.instance.SCATTER_ANTICIPATION);
            // hiding scatter anticipation animation from here when all reels are stopped
            BarbarianFuryGameModuleConfig.foregroundAnimation.hideAllAnticipationAnim();
            this._scatterAnticipationPlaying = false;
        }

        if(isWildSymPresent) {
            SlotGame.sound.playEffect(BarbarianFurySoundConfig.instance.WILD_LANDING);
        }

        // added this check for respin anticipation
        if(this._gameMode.indexOf("RESPIN") !== -1) {
            if(stopData.reelId === this._noNudgeReel[this._noNudgeReel.length - 1]) {
                BarbarianFuryGameModuleConfig.foregroundAnimation.hideAllrespinAnimation();
                this.stopReSpinAnticipationSound();
            } else if(this._noNudgeReel.lastIndexOf(stopData.reelId) !== -1) {
                let foregroundAnim = BarbarianFuryGameModuleConfig.foregroundAnimation;
                if(isActiveSymbolPresent) {
                    foregroundAnim.hideRespinAnticipation(stopData.reelId)
                } else {
                    foregroundAnim.hideAllrespinAnimation();
                    this.stopReSpinAnticipationSound();
                }
            }
        }

    }

    private stopReSpinAnticipationSound():void {
        if(this._anticipationfailSoundPlayed && (this._gameMode.indexOf("RESPIN") !== -1 || this)) {
            return;
        }
        this._anticipationfailSoundPlayed = true;
        SlotGame.sound.stopEffect("anticipation");
        this._gameData!.betWins.length === 0 && SlotGame.sound.playEffect("anticipationFail");
    }

    private playScatterSoundAndAnimation(stopData:IReelStoppedData):void {
        if(this._gameMode === BarbarianFuryGameMode.NORMAL) {
            if((stopData.reelId === 3 && this._scatterCount >= 2) || (stopData.reelId == 4 && this._scatterCount > 2) || stopData.reelId < 3) {
                SlotGame.sound.playEffect(BarbarianFurySoundConfig.instance.SCATTER + this._scatterCount);
            }
            if(this._scatterCount == 2 && stopData.reelId <= 3) {
                SlotGame.sound.playEffect(BarbarianFurySoundConfig.instance.SCATTER_ANTICIPATION);
                this._scatterAnticipationPlaying = true;
            }
            if(this._scatterCount >= 3) {
                for(let index = 0; index < this._scatterCount; index++) {
                    EventHandler.dispatchEvent(new GameEvent(BFGameEvent.STOP_SCATTER_FIRE_ANIM, 0, true, this._scatterPresentReels[index], false));
                }
            }

        }

        // for free spin
        else if(this._gameMode.indexOf("FREESPIN") !== -1) {
            EventHandler.dispatchEvent(new GameEvent(BFGameEvent.STOP_SCATTER_FIRE_ANIM, 0, true, stopData.reelId, false)); // event to play scatter roar animation
            if(this._scatterCount > 2) {
                this._scatterCount = 1;
            }
            SlotGame.sound.playEffect(BarbarianFurySoundConfig.instance.SCATTER_LANDIG_FS + this._scatterCount);
        }
    }


    private onTeaseStart(id:number, nudgeUp:boolean, stackedSpinTriggered:boolean):void {
        (Reels._reelAreaView as BFReelAreaView).startTease(id, nudgeUp, stackedSpinTriggered, () => {
            EventHandler.dispatchEvent(new GameEvent("reelTeaseCompleted", id));
        });
    }

    private onTeaseAbort(arr:any):void {
        EventHandler.dispatchEvent(new GameEvent("teaseAborted", arr));
        // stopping tease sound on abort
        SlotGame.sound.stopEffect(BarbarianFurySoundConfig.instance.RESPIN_TEASE_DOWN);
    }

    private onRoundComplete():void {
        this._anticipatingReels = [false, false, false, false, false];
    }
}